import { filter } from 'rxjs';

export const filterWidgetEvent = <
  T extends { type: string },
  K extends T['type']
>(
  type: K
) => {
  return filter(
    (payload: T): payload is Extract<T, { type: K }> => payload.type === type
  );
};
